/* eslint-disable*/
/* eslint-disable linebreak-style */
/* eslint-disable import/no-unresolved */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    // 字典类别配置
    {
      path: "/dictType-configurationTwo",
      component: () => import("@/pages/wpsp/configuration-management/dictType-configuration.vue"),
      title: "字典类别配置"
    },
    // 字典项配置
    {
      path: "/dict-configurationTwo",
      component: () => import("@/pages/wpsp/configuration-management/dict-configuration.vue"),
      title: "字典项配置"
    },
    // 参数配置
    {
      path: "/param-configurationTwo",
      component: () => import("@/pages/wpsp/configuration-management/param-configuration.vue"),
      title: "参数配置"
    },
    // 模块配置
    {
      path: "/module-configurationTwo",
      component: () => import("@/pages/wpsp/configuration-management/module-configuration.vue"),
      title: "模块配置"
    },
    // 提示配置
    {
      path: "/tip-configurationTwo",
      component: () => import("@/pages/wpsp/configuration-management/tip-configuration.vue"),
      title: "提示配置"
    },
    {
      path: "/login",
      name: "login",
      component: () => import(/* webpackChunkName: "login" */ "./pages/login.vue")
    },
    {
      // path: "/",
      // redirect: "flow1",
      path: "/flow1",
      name: "flow1",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/flow1.vue")
    },
    {
      path: "/flow2",
      name: "flow2",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/flow2.vue")
    },
    {
      path: "/flow3",
      name: "flow3",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/flow3.vue")
    },
    {
      path: "/flow4",
      name: "flow4",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/flow4.vue")
    },
    {
      path: "/flow5",
      name: "flow5",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/flow5.vue")
    },
    {
      path: "/flow6",
      name: "flow6",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/flow6.vue")
    },
    {
      path: "/flow7",
      name: "flow7",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/flow7.vue")
    },
    {
      path: "/flow8",
      name: "flow8",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/flow8.vue")
    },
    {
      path: "/esignature",
      name: "esignature",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/esignature.vue")
    },
    {
      path: "/esignature2",
      name: "esignature2",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/esignature2.vue")
    },
    {
      path: "/businessHandling",
      name: "businessHandling",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/businessHandling.vue")
    },
    {
      path: "/identityauthentication",
      name: "identityauthentication",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/identityauthentication.vue")
    },
    {
      path: "/rightvue",
      name: "rightvue",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/rightvue.vue")
    },
    {
      path: "/rightvue2",
      name: "rightvue2",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/rightvue2.vue")
    },
    {
      path: "/transfer1",
      name: "transfer1",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/transfer1.vue")
    },
    {
      path: "/Remittance",
      name: "Remittance",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/Remittance.vue")
    },
    {
      path: "/esignature3",
      name: "esignature3",
      component: () => import(/* webpackChunkName: "login" */ "./pages/demo/esignature3.vue")
    },
    {
      path: "/",
      component: () => import(/* webpackChunkName: "home" */ "./pages/home.vue"), //
      redirect: "businessHandling",
      children: [
        {
          path: "homePage",
          component: () => import(/* webpackChunkName: "home-page" */ "./pages/home-page.vue")
        },
        // 客户管理模块 - 客户列表
        {
          path: "Home",
          component: () => import(/* webpackChunkName: "custList" */ "@/pages/customer-management/customer-list/Home"),
          title: "客户列表"
        },
        // 客户视图
        {
          path: "CustomerView",
          component: () => import(/* webpackChunkName: "today-performance" */ "@/pages/Customer-view/Customer-view.vue")
        },
        // 资产分析
        {
          path: "Assets-analysis",
          component: () => import(/* webpackChunkName: "today-performance" */ "@/pages/Customer-view/Assets-analysis")
        },
        // 资产配置
        {
          path: "finance-config",
          name: "financeConfig",
          component: () => import(/* webpackChunkName: "finance-config" */ "./pages/wpsp/finance-config/finance-config.vue") //
        },
        // 基本信息页面
        {
          path: "/basicLayout",
          component: () => import(/* webpackChunkName: "job-run-log" */ "@/pages/wpsp/basicLayout.vue")
        },
        // 子女
        {
          path: "/children-educationHome",
          name: "children-educationHome",
          component: () => import(/* webpackChunkName: "login" */ "./pages/wpsp/children-education/children-educationHome.vue")
        },
        // 养老
        {
          path: "/pension-planningHome",
          name: "pension-planningHome",
          component: () => import(/* webpackChunkName: "login" */ "./pages/wpsp/pension-planning/pension-planningHome.vue")
        },
        // 报告
        {
          path: "/Presentation",
          name: "Presentation",
          component: () => import(/* webpackChunkName: "login" */ "./pages/wpsp/PlanningReport/PresentationList.vue")
        },

        // 定时任务 - job 管理
        {
          path: "timeTaskManage",
          component: () => import(/* webpackChunkName: "job-management" */ "@/pages/job/job-management")
        },
        // 参数设置 - 双录参数
        {
          path: "videoPage",
          component: () => import(/* webpackChunkName: "audio-param" */ "@/pages/scene/record-video-config")
        },
        // 现场服务模块
        // 现场服务模块 - 音频上传参数
        {
          path: "audioParam",
          component: () => import(/* webpackChunkName: "audio-param" */ "@/pages/scene/audio-param")
        },
        // 现场服务模块 - 现场服务记录
        {
          path: "fieldServRecordQuery",
          component: () => import(/* webpackChunkName: "on-site-service-record" */ "@/pages/scene/on-site-service-record")
        },
        // 现场服务模块 - 现场服务明细
        {
          path: "makeUpEntrance",
          component: () => import(/* webpackChunkName: "on-site-service-detail" */ "@/pages/scene/on-site-service-record/on-site-service-detail.vue")
        },
        // 日志模块 - 交易日志
        {
          path: "sysTransactionLog",
          component: () => import(/* webpackChunkName: "transaction-log" */ "@/pages/log/transaction-log")
        },
        // 日志模块 - 交易日志详情
        {
          path: "sysTransactionLogDetail",
          component: () => import(/* webpackChunkName: "transaction-log-detail" */ "@/pages/log/transaction-log/transaction-log-detail.vue")
        },

        // 日志模块 - job 运行日志
        {
          path: "runLogMain",
          component: () => import(/* webpackChunkName: "job-run-log" */ "@/pages/log/job-run-log")
        },

        // 日志模块 - 操作日志
        {
          path: "sysLog",
          component: () => import(/* webpackChunkName: "operational-log" */ "@/pages/log/operational-log"),
          title: "操作日志"
        },
        // 日志模块 - 人员登录日志
        {
          path: "logManage",
          component: () => import(/* webpackChunkName: "personnel-login-log" */ "@/pages/log/personnel-login-log"),
          title: "人员登录日志"
        },
        // 日志模块 - 报文日志
        {
          path: "translogsocket",
          component: () => import(/* webpackChunkName: "message-log" */ "@/pages/log/message-log"),
          title: "报文日志"
        },
        {
          path: "translogsocketDetail",
          component: () => import(/* webpackChunkName: "translogsocket-detail" */ "@/pages/log/message-log/translogsocket-detail.vue"),
          title: "报文日志详情"
        },
        // 统一认证模块 - 角色管理
        {
          path: "roleManage",
          component: () => import(/* webpackChunkName: "role-management" */ "@/pages/authority/role-management"),
          title: "角色管理"
        },
        // 统一认证模块 - 菜单管理
        {
          path: "menuManagement",
          component: () => import(/* webpackChunkName: "menu-management" */ "@/pages/authority/menu-management"),
          title: "菜单管理"
        },
        // 统一认证模块 - 功能管理
        {
          path: "funcManagement",
          component: () => import(/* webpackChunkName: "function-management" */ "@/pages/authority/function-management"),
          title: "功能管理"
        },
        // 统一认证模块 - 机构管理
        {
          path: "organManage",
          component: () => import(/* webpackChunkName: "institutions-management" */ "@/pages/authority/institutions-management"),
          title: "机构管理"
        },
        // 统一认证模块 - 终端维护
        {
          path: "Terminal",
          component: () => import(/* webpackChunkName: "terminal-maintenance" */ "@/pages/authority/terminal-maintenance"),
          title: "终端维护"
        },
        // 统一认证模块 - 人员管理
        {
          path: "userManagement",
          component: () => import(/* webpackChunkName: "user-management" */ "@/pages/authority/user-management"),
          title: "人员管理"
        },
        {
          path: "addUser",
          component: () => import(/* webpackChunkName: "add-user" */ "@/pages/authority/user-management/add-user.vue"),
          title: "人员管理新增"
        },
        {
          path: "editUser",
          component: () => import(/* webpackChunkName: "edit-user" */ "@/pages/authority/user-management/edit-user.vue"),
          title: "人员管理修改"
        },
        // 维护管理模块 - 字典管理
        {
          path: "sysDictManagement",
          component: () => import(/* webpackChunkName: "dictionary-management" */ "@/pages/maintenance/dictionary-management"),
          title: "字典管理"
        },
        {
          path: "sysDicInfo",
          component: () => import(/* webpackChunkName: "dictionary-detail" */ "@/pages/maintenance/dictionary-management/dictionary-detail.vue"),
          title: "字典项列表"
        },
        // 维护管理模块 - 参数设置
        {
          path: "paramManage",
          component: () => import(/* webpackChunkName: "parameter-setting" */ "@/pages/maintenance/parameter-setting"),
          title: "参数设置"
        },
        // 维护管理模块 - 屏保管理
        {
          path: "productHome/screen",
          component: () => import(/* webpackChunkName: "screensaver-management" */ "@/pages/maintenance/screensaver-management"),
          title: "屏保管理"
        },
        // 报表模块 - 产品报表
        {
          path: "productHome/dealCollectTable",
          component: () => import(/* webpackChunkName: "product-statement" */ "@/pages/report/product-statement"),
          title: "屏保管理"
        },
        // 客户管理模块 - 线索客户
        {
          path: "/leadCust",
          component: () => import(/* webpackChunkName: "leadCust" */ "@/pages/customer-management/leads"),
          title: "线索客户"
        },
        {
          path: "addLead",
          component: () => import(/* webpackChunkName: "add-lead" */ "@/pages/customer-management/leads/add.vue"),
          title: "新增线索"
        },
        {
          path: "editLead",
          component: () => import(/* webpackChunkName: "edit-lead" */ "@/pages/customer-management/leads/edit.vue"),
          title: "修改线索"
        },
        // 客户管理模块 - 客户列表
        {
          path: "/custList",
          // component: () => import(/* webpackChunkName: "custList" */ '@/pages/customer-management/customer-list'),
          component: () => import(/* webpackChunkName: "custList" */ "@/pages/customer-management/customer-list/Home"),
          title: "客户列表"
        },
        // 客户管理模块 - 电访计划
        {
          path: "call-plan",
          component: () => import(/* webpackChunkName: "call-plan" */ "@/pages/customer-management/call-plan"),
          title: "电访计划"
        },
        // 产品管理模块 - 大额存单
        {
          path: "cds-list",
          component: () => import(/* webpackChunkName: "cds-list" */ "@/pages/product-management/cds-list"),
          title: "大额存单"
        },
        // 产品管理模块 - 附件管理
        {
          path: "annex-list",
          component: () => import("@/pages/product-management/annex-list"),
          title: "附件管理"
        },
        {
          path: "annex-preview",
          component: () => import("@/pages/product-management/annex-list/annex-preview"),
          title: "附件预览"
        },
        {
          path: "risk-tip",
          component: () => import(/* webpackChunkName: "risk-tip" */ "@/pages/product-management/risk-tip"),
          title: "风险话术"
        },
        {
          path: "add-risk-tip",
          component: () => import(/* webpackChunkName: "add-risk-tip" */ "@/pages/product-management/risk-tip/add-risk-tip")
        },
        {
          path: "edit-risk-tip",
          component: () => import(/* webpackChunkName: "edit-risk-tip" */ "@/pages/product-management/risk-tip/edit-risk-tip")
        },
        {
          path: "cds-detail",
          component: () => import(/* webpackChunkName: "cds-detail" */ "@/pages/product-management/cds-list/cds-detail"),
          title: "产品详情"
        },
        // 产品管理模块 - 产品配置管理
        {
          path: "management-list",
          component: () => import("@/pages/configuration-management/index"),
          title: "产品配置管理"
        },
        // 参数配置
        {
          path: "param-configuration",
          component: () => import("@/pages/wpsp/configuration-management/param-configuration.vue"),
          title: "参数配置"
        },
        // 模块配置
        {
          path: "module-configuration",
          component: () => import("@/pages/wpsp/configuration-management/module-configuration.vue"),
          title: "模块配置"
        },
        // 提示配置
        {
          path: "tip-configuration",
          component: () => import("@/pages/wpsp/configuration-management/tip-configuration.vue"),
          title: "提示配置"
        },
        // 字典类别配置
        {
          path: "dictType-configuration",
          component: () => import("@/pages/wpsp/configuration-management/dictType-configuration.vue"),
          title: "字典类别配置"
        },
        // 字典项配置
        {
          path: "dict-configuration",
          component: () => import("@/pages/wpsp/configuration-management/dict-configuration.vue"),
          title: "字典项配置"
        },
        // 子女规划-产品管理-理财表格
        {
          path: "finance-table",
          component: () => import("@/pages/wpsp/children-education/product-table/finance-table.vue"),
          title: "理财表格"
        },
        // 子女规划-产品管理-储蓄表格
        {
          path: "deposit-table",
          component: () => import("@/pages/wpsp/children-education/product-table/deposit-table.vue"),
          title: "储蓄表格"
        },
        // 产品理模块 - 理财产品
        {
          path: "financialTransactions",
          component: () => import(/* webpackChunkName: "financialTransactions" */ "@/pages/product-management/financial-transactions"),
          title: "理财产品"
        },
        {
          path: "financiaPrdDetail",
          component: () => import(/* webpackChunkName: "financialTransactions" */ "@/pages/product-management/financial-transactions/financial-detail.vue"),
          title: "理财产品详情"
        },
        {
          path: "no-access",
          name: "无权限",
          component: () => import(/* webpackChunkName: "no-access" */ "./pages/no-access.vue")
        },
        {
          path: "exam-list",
          component: () => import(/* webpackChunkName: "exam-list" */ "@/pages/product-management/exam")
        },
        {
          path: "exam-paper",
          component: () => import(/* webpackChunkName: "exam-paper" */ "@/pages/product-management/exam-paper")
        },
        {
          path: "add-exam-paper",
          component: () => import(/* webpackChunkName: "add-exam-paper" */ "@/pages/product-management/exam-paper/add-exam-paper")
        },
        {
          path: "edit-exam-paper",
          component: () => import(/* webpackChunkName: "add-exam-paper" */ "@/pages/product-management/exam-paper/edit-exam-paper")
        },
        {
          path: "today-performance",
          component: () => import(/* webpackChunkName: "today-performance" */ "@/pages/aside/today-performance")
        },
        {
          path: "latest-product",
          component: () => import(/* webpackChunkName: "today-performance" */ "@/pages/aside/latest-product")
        },
        // 客户视图
        {
          path: "CustomerView-Home",
          component: () => import(/* webpackChunkName: "today-performance" */ "@/pages/Customer-view/Customer-view.vue")
        },
        // 资产分析
        {
          path: "Assets-analysis-Home",
          component: () => import(/* webpackChunkName: "today-performance" */ "@/pages/Customer-view/Assets-analysis")
        },
        // 资产配置
        {
          path: "finance-config-Home",
          name: "financeConfig",
          component: () => import(/* webpackChunkName: "finance-config" */ "./pages/wpsp/finance-config/finance-config.vue") //
        },
        {
          path: "basicLayout",
          component: () => import(/* webpackChunkName: "home" */ "./pages/wpsp/basicLayout.vue"), //
          redirect: "/basicLayout/basicMain",
          children: [
            // 基本信息页面
            {
              path: "basicMain",
              component: () => import(/* webpackChunkName: "job-run-log" */ "@/pages/wpsp/base-information/basicMain.vue")
            }
          ]
        },
        {
          // 404 请放置于底部
          path: "404",
          name: "404",
          component: () => import(/* webpackChunkName: "404" */ "./pages/404.vue")
        }
      ]
    },

    {
      path: "*",
      redirect: "/404"
    }
  ]
});
